require('./slider-css-injector.js');
require('./brizyCounter.js');
require('./brizyPopup.js');
require('./animations');
require("./video.js");
require('./smoothScroll.js');
require('./imageViewer.js');
require('./madLazyBackgroundImage.js');
require('./wpforms.js');
require('./buttonAnnotation.js');

class Util {
  constructor() {
    // Initialize cookies object with all existing cookies
    this.cookies = this.getAllCookies();

    // Bind event handlers
    this.bindEvents();
  }

  bindEvents() {
    // Listen for madConsentApplied event
    jQuery(document).on("madConsentApplied", (event, data) => {
      // Update cookies object based on consent
      this.cookies = this.getAllCookies(); // Refresh the cookies object
      this.handleConsentApplied(data.consent);
    });
  }

  getAllCookies() {
    const cookies = {};
    const cookieString = document.cookie;
    const cookieArray = cookieString.split(";");

    cookieArray.forEach((cookie) => {
      const [rawName, ...rawValueParts] = cookie.split("=");
      const name = rawName.trim();
      const value = rawValueParts.join("=").trim();

      if (name) {
        cookies[name] = decodeURIComponent(value);
      }
    });

    // console.log("All cookies:", cookies);

    return cookies;
  }

  handleConsentApplied(consent) {
    // Your logic based on the consent state
    console.log("Consent applied:", consent);

    // Example: Initialize scripts based on consent
    // Iterate over consent object
    Object.keys(consent).forEach((categorySlug) => {
      const categoryConsent = consent[categorySlug];
      Object.keys(categoryConsent).forEach((cookieName) => {
        const consentGiven = categoryConsent[cookieName];
        if (consentGiven) {
          // Initialize scripts or perform actions for this cookie
          this.initializeCookieScript(cookieName);
        } else {
          // Optionally handle revocation of consent
          this.deinitializeCookieScript(cookieName);
        }
      });
    });
  }

  initializeCookieScript(cookieName) {
    // Your logic to initialize scripts based on cookieName
    if (cookieName === "google_analytics") {
    }
    // Add other cookies as needed
  }

  deinitializeCookieScript(cookieName) {
    // Your logic to deinitialize scripts if needed
    if (cookieName === "google_analytics") {
    }
    // Add other cookies as needed
  }

  updateFragments(fragments) {
    if (fragments) {
      for (const fragmentSelector in fragments) {
        const fragmentContent = fragments[fragmentSelector];
        // console.log(fragmentSelector, fragmentContent);
        jQuery(fragmentSelector).replaceWith(fragmentContent);
      }
    }
  }

  blockElement(element, userOptions) {
    if (!element) return;
    element = jQuery(element);

    // Ensure the element has position: relative if it does not have a suitable positioning
    const currentPosition = element.css("position");
    if (
      !["relative", "absolute", "fixed", "sticky"].includes(currentPosition)
    ) {
      element.css("position", "relative");
    }

    const defaultOptions = {
      overlay: {
        backgroundColor: "#212121",
        opacity: 0.25,
      },
      icon: {
        size: "medium",
        color: "#000",
        positionX: "center",
        positionY: "center",
      },
    };

    const options = this.deepMerge({}, defaultOptions);
    if (userOptions) this.deepMerge(options, userOptions);

    const loadingOverlay = jQuery('<div class="mad-loading-overlay"></div>')
      .addClass(`px-${options.icon.positionX}`)
      .addClass(`py-${options.icon.positionY}`);

    const loadingOverlayBackground = jQuery(
      '<div class="mad-loading-overlay__bg"></div>'
    ).css({
      "background-color": options.overlay.backgroundColor,
      opacity: options.overlay.opacity,
    });

    const loadingIconSizeClass = `s-${options.icon.size}`;
    const loadingIcon = jQuery(
      '<div class="mad-loading"><div></div><div></div><div></div><div></div></div>'
    )
      .addClass(loadingIconSizeClass)
      .css({
        color: options.icon.color,
      });

    loadingOverlay.append(loadingIcon);
    loadingOverlay.append(loadingOverlayBackground);

    element.append(loadingOverlay);
  }

  unblockElement(element) {
    if (!element) return;
    element = jQuery(element);

    jQuery(element).find(".mad-loading-overlay").remove();
  }

  deepMerge(target, source) {
    Object.keys(source).forEach((key) => {
      if (source[key] && typeof source[key] === "object") {
        if (!target[key]) {
          target[key] = {};
        }
        this.deepMerge(target[key], source[key]);
      } else {
        target[key] = source[key];
      }
    });
    return target;
  }

  isValidJson(rawJson) {
    try {
      var json = JSON.parse(rawJson);

      return json && "object" === typeof json;
    } catch (e) {
      return false;
    }
  }
}

window.$madUtil = new Util();

function adjustAdminBarHeightVariable() {
  const adminBar = jQuery("#wpadminbar");

  if (adminBar.length) {
      const adminBarHeight = adminBar.outerHeight();
      setBodyCssVariable("--mad-adminbar-height", `${adminBarHeight}px`);
  }
}

function setBodyCssVariable(variableName, value) {
  document.body.style.setProperty(variableName, value);
}

// Execute on page load
jQuery(document).ready(function () {
  adjustAdminBarHeightVariable();
});
